import PropTypes from 'prop-types'
import { useState, useEffect, Fragment } from 'react'
import { useAuth } from '../../hooks/useAuth'
import ComponenteError from '../publicaciones/ComponenteError'
import * as presupuestosService from '../servicios/presupuestosService'
import BordePrincipal from '../ui/BordePrincipal'
import Presupuesto from './Presupuesto'
import styles from './Presupuestos.module.css'

const ID_AVISO_COMPRADOR = 20
const ID_AVISO_VENDEDOR = 21

const Presupuestos = ({ esVendedor }) => {
  const { loginDataContext: { idUsuario, empid } = {}, esPerfilAdmin } = useAuth()
  const [presupuestos, setPresupuestos] = useState([])
  const [sinResultados, setSinResultados] = useState(false)

  const fetchPresupuestos = async () => {
    const { data } = esPerfilAdmin
      ? await presupuestosService.buscarPorEmpresa(empid, esVendedor)
      : esVendedor
        ? await presupuestosService.buscarPorVendedor(idUsuario)
        : await presupuestosService.buscarPorComprador(idUsuario)
    setPresupuestos(data)
    setSinResultados(data.length === 0)
  }

  useEffect(() => {
    if (!idUsuario || !empid) return

    fetchPresupuestos()
  }, [esVendedor, idUsuario, empid, esPerfilAdmin])

  return (
    <>
      <BordePrincipal titulo="Mis Presupuestos" className={styles.presupuestoFieldset}>
        {!sinResultados ? (
          presupuestos.map((presupuesto) => (
            <Fragment key={presupuesto.idPresupuesto}>
              <Presupuesto
                presupuesto={presupuesto}
                canAdministrate={esVendedor}
                esAdmin={esPerfilAdmin}
              />
            </Fragment>
          ))
        ) : (
          <div className="row">
            <ComponenteError
              tipo="I"
              idAviso={esVendedor ? ID_AVISO_VENDEDOR : ID_AVISO_COMPRADOR}
            />
          </div>
        )}
      </BordePrincipal>
    </>
  )
}

Presupuestos.propTypes = {
  esVendedor: PropTypes.bool
}

export default Presupuestos
